import React, { useRef, useState } from 'react';

import Icon from '../../Icons';

import Modal from '../../Modal';
import Button from '../../Button';

import Divider from '../../Divider';
import { useGlobal } from '../../../contexts/Global/context';

import * as S from './styles';

function CardDocument({
    id,
    name,
    label,
    files,
    indexDependente = false,
    isOthers = false,
    onLabelClick = () => {},
    onFileChange = () => {},
    onClickViewFile = () => {},
    onDeleteFile = () => {},
}) {
    const attachInput = useRef(null);
    const [visibleDialog, setVisibleDialog] = useState(false);
    const { contrastTheme } = useGlobal();

    function handleClickViewFile(dataFile) {
        onClickViewFile(dataFile);
    }

    function handleClickAttach() {
        attachInput.current.click();
    }

    return (
        <S.Container>
            <S.Card>
                <S.AttachContainer className={files.length && 'has-doc'}>
                    <S.LeftContent>
                        <S.StyledIcon>
                            {files.length > 0 ? (
                                <Icon name="CheckCircle" color={contrastTheme ? '#FFFFFF' : '#0B8A1C'} size={30} />
                            ) : (
                                <Icon name="description" color={contrastTheme ? '#FFFFFF' : '#5B5B5F'} size={30} />
                            )}
                        </S.StyledIcon>
                        <S.Content>
                            <span className="name">{name === "Termo DAP assinado" ? `${name} (disponível no passo anterior)` : name}</span>
                            {label && (
                                <span className="link" onClick={onLabelClick}>
                                    {label}
                                </span>
                            )}
                        </S.Content>
                    </S.LeftContent>
                    <S.Actions>
                        <div className="attach-icon" onClick={handleClickAttach}>
                            <Icon name="attachment" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                            <span>Anexar</span>
                            <input
                                id={`input-${id}${indexDependente !== false ? `-${indexDependente}` : ''}`}
                                type="file"
                                accept="application/pdf, image/jpeg, image/png"
                                onChange={(event) => onFileChange(event)}
                                ref={attachInput}
                            />
                        </div>
                    </S.Actions>
                </S.AttachContainer>
                {files.length > 0 &&
                    files.map((file, indexFile) => (
                        <React.Fragment key={`${file.name}-${file.size}`}>
                            <Divider />
                            <S.AttachContainer className="doc">
                                <S.LeftContent>
                                    <S.StyledIcon>
                                        <Icon
                                            name="description"
                                            color={contrastTheme ? '#FFFFFF' : '#5B5B5F'}
                                            size={30}
                                        />
                                    </S.StyledIcon>
                                    <S.Content>
                                        <span>{file.name}</span>
                                        <span>{file.size}</span>
                                    </S.Content>
                                </S.LeftContent>
                                <S.Actions>
                                    <>
                                        <div id={`${id}-view-${indexFile}`} onClick={() => handleClickViewFile(file)}>
                                            <Icon
                                                title="Visualizar"
                                                name="plagiarism"
                                                color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                                            />
                                        </div>
                                        <div id={`${id}-delete-${indexFile}`} onClick={() => setVisibleDialog(true)}>
                                            <Icon
                                                title="Excluir"
                                                name="delete"
                                                color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                                            />
                                        </div>
                                        {visibleDialog && (
                                            <Modal
                                                title="Você quer excluir este arquivo?"
                                                subtitle="O arquivo será definitivamente excluído da plataforma."
                                                visible
                                                footer={null}
                                                onCancel={() => setVisibleDialog(false)}
                                            >
                                                <Button type="secondary" onClick={() => setVisibleDialog(false)}>
                                                    Não quero
                                                </Button>
                                                <Button
                                                    type="primary"
                                                    onClick={() => {
                                                        setVisibleDialog(false);
                                                        onDeleteFile({
                                                            id,
                                                            indexDependente,
                                                            isOthers,
                                                            fileName: file.name,
                                                        });
                                                    }}
                                                >
                                                    Sim, quero
                                                </Button>
                                            </Modal>
                                        )}
                                    </>
                                </S.Actions>
                            </S.AttachContainer>
                        </React.Fragment>
                    ))}
            </S.Card>
        </S.Container>
    );
}

export default CardDocument;
